import rtrim from './rtrim.js';
import ltrim from './ltrim.js';

function trim(str,chars){return rtrim(ltrim(str))}

export { trim as default };
//# sourceMappingURL=trim.js.map
